import { render, staticRenderFns } from "./EditTagsGroupDialog.vue?vue&type=template&id=f42f9aa4"
import script from "./EditTagsGroupDialog.vue?vue&type=script&lang=js"
export * from "./EditTagsGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports